import React from 'react';
import { GavelRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LegalDocument from '../components/LegalDocument';
import PublicPageLayout from '../components/PublicPageLayout';

const TermCondition = () => {
  const { t } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);
  const sections = Array.from({ length: 12 }, (_, index) => ({
    heading: t(`term_condition_heading${index + 1}`),
    id: index + 1,
    paragraph: t(`term_condition_para${index + 2}`)
  }));

  return (
    <PublicPageLayout
      contentMaxWidth="md"
      eyebrow={t('terms_of_service', { defaultValue: 'Terms of service' })}
      icon={<GavelRounded sx={{ fontSize: 23 }} />}
      subtitle={t('terms_page_subtitle', {
        defaultValue: 'The conditions that guide access to and use of the Laiwani service.'
      })}
      title={t('term_condition')}
    >
      <LegalDocument
        description={t('terms_document_description', {
          defaultValue: 'Please review these terms carefully before using the Laiwani platform or related services.'
        })}
        label={t('terms_document_label', { defaultValue: 'Using Laiwani' })}
      >
        <p>{t('term_condition_para1')}</p>
        {sections.map((section) => (
          <React.Fragment key={section.id}>
            <p><strong>{section.heading}</strong></p>
            <p>{section.paragraph}</p>
          </React.Fragment>
        ))}
        <p>
          {t('term_condition_para14')}{' '}
          {settings && settings.contact_email ? (
            <a href={`mailto:${settings.contact_email}`}>
              <strong>{settings.contact_email}</strong>
            </a>
          ) : null}
        </p>
      </LegalDocument>
    </PublicPageLayout>
  );
};

export default TermCondition;
